class CartDrawer extends CustomElement {
  firstVisit = true;

  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  get refs() {
    return {
      scrollableContent: this.$el.find("cart-scrollable-content").get(0),
      cartSummary: document.getElementById("CartDrawerSummary"),
      cartRedeem: document.getElementById("CartRedeemCode"),
      cartItems: this.querySelector("cart-drawer-items"),
      //cartUpsell: this.querySelector('cart-upsell'),
      cartIconBubble: document.getElementById("cart-icon-bubble"),
    };
  }

  async mounted() {
    const isEmpty = this.$el.hasClass("is-empty");
    const { cartRedeem } = this.refs;
  }

  async loadCheckout() {
    const { cartItems, cartUpsell, cartRedeem, cartIconBubble } = this.refs;

    this.loading = true;
    cartItems.disabled = true;
    cartRedeem.loading = true;
    cartIconBubble.loading = true;
    //cartUpsell.disabled = true

    try {
      //await this.parseCheckoutPage();
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
      cartItems.disabled = false;
      cartRedeem.loading = false;
      cartIconBubble.loading = false;
      //cartUpsell.disabled = false
    }
  }

  async parseCheckoutPage() {
    let gettingShopifyCheckoutPagePromise = fetch("/checkout", {
      method: "get",
      mode: "cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });
    const response = (await gettingShopifyCheckoutPagePromise).clone();
    gettingShopifyCheckoutPagePromise = null;
    try {
      /*
      const urlParts = response.url.includes('checkouts/cn') ? response.url.split('/checkouts/cn/') :  response.url.split('/checkouts/c/');
      if (urlParts.length < 2) {
        return false;
      }*/
      const text = await response.text();
      let parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      this.checkout = JSON.parse(
        doc
          .querySelector('meta[name="serialized-graphql"]')
          .getAttribute("content")
      );
      this.checkoutSessionToken = JSON.parse(
        doc
          .querySelector('meta[name="serialized-session-token"]')
          .getAttribute("content")
      );
      Object.keys(this.checkout).forEach((index) => {
        if (this.checkout[index].session) {
          this.checkoutSession = this.checkout[index].session;
          this.xCheckoutWebSourceId = this.checkoutSession.sourceId;
        }
      });

      this.checkoutQueueToken =
        this.checkoutSession.negotiate.result.queueToken;

      return true;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  async updateCheckoutData(payload) {
    const response = await this.requestCheckout(payload);
    this.checkout = response;
    Object.keys(this.checkout).forEach((index) => {
      if (this.checkout[index].session) {
        this.checkoutSession = this.checkout[index].session;
      }
    });
  }

  async requestCheckout(payload, method = "POST") {
    const response = await fetch(`/checkouts/unstable/graphql`, {
      method,
      mode: "cors",
      headers: {
        Accept: "application/json",
        "Cache-Control": "max-age=0",
        "x-checkout-web-build-id": this.xCheckoutWebBuildId,
        "x-checkout-web-deploy-stage": "production",
        "x-checkout-web-server-handling": "fast",
        "x-checkout-web-source-id":
          this.checkoutSession.sourceId || this.xCheckoutWebSourceId,
        "x-checkout-one-session-token": this.checkoutSessionToken,
        "Content-Type": "application/json",
      },
      ...(!!payload
        ? { body: JSON.stringify(payload) }
        : this.getRefinedCheckoutRequestData()),
    });
    if (response.status === 429) {
      throw "You have tried applying discount codes too many times. Please try again later";
    }
    if (response.ok) {
      return response.json();
    } else {
      throw await response.json();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // if (triggeredBy) this.setActiveElement(triggeredBy);
    // const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    // if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // // here the animation doesn't seem to always get triggered. A timeout seem to help
    // setTimeout(() => {this.classList.add('animate', 'active')});

    // this.addEventListener('transitionend', () => {
    //   const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
    //   const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
    //   trapFocus(containerToTrapFocusOn, focusElement);
    // }, { once: true });

    // document.body.classList.add('overflow-hidden');
    handleFloCartBtn();
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  beforeMount() {
    super.beforeMount();

    this.$el.attr("id", `CartDrawerItems`);
  }

  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class CartDrawerSummary extends CustomElement {
  props = {
    originalPrice: 0,
  };

  beforeMount() {
    this.mutationObserver.observe(this, {
      childList: true,
      subtree: true,
      characterDataOldValue: true,
    });
  }

  mounted() {
    const $originalPriceEl = this.$el.find("#CartOriginalPrice");
    const $totalPriceEl = this.$el.find("#CartTotalPrice");
    const $totalSavedEl = this.$el.find("#CartTotalSaved");

    const totalPrice = $totalPriceEl.data("total");
    const originalPrice = $totalPriceEl.data("original-price");

    if (totalPrice === originalPrice) {
      $originalPriceEl.addClass("hidden");
      $totalSavedEl.addClass("hidden");
    }
  }

  onMutation(mutationRecords) {
    const hasCartTotalsChanged = mutationRecords.some(
      (r) => r.target.id === "CartTotals"
    );

    const hasTotalPriceChanged = mutationRecords.some(
      (r) => r.target.id === "CartTotalPrice" && !!r.addedNodes.length
    );

    if (!!hasCartTotalsChanged || !!hasTotalPriceChanged) {
      this.onPriceChange();
    }
  }

  onPriceChange() {
    console.log("onPriceChange");

    const $originalPriceEl = this.$el.find("#CartOriginalPrice");
    const $totalPriceEl = this.$el.find("#CartTotalPrice");
    const $totalSavedEl = this.$el.find("#CartTotalSaved");

    const totalPrice = parseFloat($totalPriceEl.data("total"));
    const discountedTotal = parseFloat(
      $totalPriceEl.data("discounted-total") || 0
    );
    const originalPrice = parseFloat($totalPriceEl.data("original-price"));

    if (
      originalPrice > totalPrice ||
      (!!discountedTotal && originalPrice > discountedTotal)
    ) {
      $originalPriceEl.removeClass("hidden");
      $totalSavedEl.removeClass("hidden");
    } else {
      $originalPriceEl.addClass("hidden");
      $totalSavedEl.addClass("hidden");
    }
  }

  clearTotalPrice() {
    const $totalPriceEl = this.$el.find("#CartTotalPrice");

    const totalPrice = $totalPriceEl.data("total");
    const originalPrice = $totalPriceEl.data("original-price");

    this.refreshCartPrices(totalPrice, originalPrice);
  }

  computeDiscountedTotal() {
    console.log("computeDiscountedTotal");
    /*
    const cart = document.querySelector('cart-drawer');

    const checkout = cart.checkoutSession

    const $totalComparePriceEl = this.$el.find("[data-total-compare-price]");

    const totalPrice = parseFloat(checkout.negotiate.result.sellerProposal.runningTotal.value.amount);
    const totalComparePrice = parseFloat($totalComparePriceEl.data('total-compare-price'));
    const originalPrice = parseFloat(checkout.negotiate.result.buyerProposal.runningTotal.value.amount);
    this.refreshCartPrices(totalPrice, Math.max(originalPrice, totalComparePrice / 100))*/
  }

  refreshCartPrices(finalPrice, originalPrice) {
    const $totalPriceEl = this.$el.find("#CartTotalPrice");
    const $totalSavedEl = this.$el.find("#CartTotalSaved");

    const totalSaved = originalPrice - finalPrice;

    const totalPriceInCurrency = Currency.format(finalPrice, {
      maximumFractionDigits: finalPrice % 1 === 0 ? 0 : 2,
    });
    const totalSavedInCurrency = Currency.format(totalSaved, {
      maximumFractionDigits: totalSaved % 1 === 0 ? 0 : 2,
    });

    $totalPriceEl.data("discounted-total", finalPrice);
    console.log("Total", totalPriceInCurrency);

    $totalPriceEl.text(totalPriceInCurrency);
    $totalSavedEl.find(".saved-amount").text(totalSavedInCurrency);
    $totalSavedEl.toggleClass("hidden", totalSaved <= 0);
  }
}

customElements.define("cart-drawer-summary", CartDrawerSummary);

class CartRedeemCode extends CustomElement {
  // Added Code for Discount Cookie
  createCookie(e, t, n) {
    if (n) {
      var a = new Date();
      a.setTime(a.getTime() + n * 1 * 60 * 60 * 1e3);
      var c = "; expires=" + a.toGMTString();
    } else c = "";
    document.cookie = e + "=" + t + c + "; path=/";
  }

  readCookie(e) {
    for (
      var t = e + "=", n = document.cookie.split(";"), a = 0;
      a < n.length;
      a++
    ) {
      for (var c = n[a]; " " == c.charAt(0); ) c = c.substring(1, c.length);
      if (0 == c.indexOf(t)) return c.substring(t.length, c.length);
    }
    return null;
  }

  eraseCookie(e) {
    createCookie(e, "", -1);
  }

  // Added Code for Discount Cookie

  get refs() {
    return {
      $discountViewer: this.$el.find(".discount-viewer"),
      $redeemBox: this.$el.find(".redeem-box"),
      cartSummary: this.closest("cart-drawer-summary"),
      scrollableContent: this.$el.find("cart-scrollable-content").get(0),
      cartItems: document.getElementById("CartDrawerItems"),
      //cartUpsell: document.getElementById('CartDrawerUpsell'),
      cartIconBubble: document.getElementById("cart-icon-bubble"),
    };
  }

  codeRedeemed = false;

  beforeMount() {
    this.$cart = document.querySelector("cart-drawer");

    this.$input = this.$el.find("input");
    this.$applyBtn = this.$el.find("#CartApplyDiscount");
    this.$removeBtn = this.$el.find(".CartRemoveDiscount");

    this.$input.on("keypress", (e) => {
      if (e.which == 13) {
        this.applyDiscount();
      }
    });
    this.$applyBtn.click(this.applyDiscount.bind(this));
    this.$el.on("click", ".CartRemoveDiscount", (e) => {
      const codes = [$(e.target).closest("[data-code]").attr("data-code")];
      this.removeDiscount(codes);
    });
  }

  onLoad(isLoading) {
    super.onLoad(isLoading);

    this.$input.attr("disabled", !!isLoading);
    this.$applyBtn.attr("disabled", !!isLoading);
    this.$removeBtn.attr("disabled", !!isLoading);
  }

  refinedMerchandiseLines(lines = []) {
    return lines.map((line) => {
      return {
        stableId: line.stableId,
        merchandise: {
          productVariantReference: {
            id: line.merchandise.id,
            variantId: line.merchandise.variantId,
            properties: this.refinedCheckoutObject(
              line.merchandise.properties,
              ["visible"]
            ),
            sellingPlanId: line.merchandise.sellingPlan,
            sellingPlanDigest: line.merchandise.digest,
          },
        },
        quantity: line.quantity,
        expectedTotalPrice: {
          value: {
            amount: line.totalAmount.value.amount,
            currencyCode: line.totalAmount.value.currencyCode,
          },
        },
        lineComponents: line.lineComponents,
      };
    });
  }

  refinedDeliveryLines(lines = []) {
    return lines.map((line) => {
      const selectedDeliveryStrategy =
        line.availableDeliveryStrategies.find(
          (s) => s.handle === line.selectedDeliveryStrategy.handle
        ) || line.availableDeliveryStrategies[0];
      return {
        destination: {
          partialStreetAddress: this.refinedCheckoutObject(
            line.destinationAddress,
            ["name"]
          ),
        },
        selectedDeliveryStrategy: {
          deliveryStrategyByHandle: {
            customDeliveryRate: false,
            handle: line.selectedDeliveryStrategy.handle,
          },
          options: {},
        },
        targetMerchandiseLines: {
          lines: [],
        },
        deliveryMethodTypes: ["SHIPPING"],
        expectedTotalPrice: selectedDeliveryStrategy
          ? {
              value: {
                amount: selectedDeliveryStrategy.amount.value.amount,
                currencyCode:
                  selectedDeliveryStrategy.amount.value.currencyCode,
              },
            }
          : {
              value: {
                amount: "0",
                currencyCode:
                  this.$cart.checkoutSession.negotiate.result.sellerProposal
                    .buyerIdentity.customer.presentmentCurrency,
              },
            },
      };
    });
  }

  refinedCheckoutObject(obj, excludedKeys = []) {
    try {
      if (!obj) return obj;
      if (Array.isArray(obj)) {
        return obj.map((v) => this.refinedCheckoutObject(v, excludedKeys));
      }
      if (typeof obj !== "object") {
        return obj;
      }

      let refinedObj = {};
      Object.keys(obj).forEach((key) => {
        if (
          ![
            "__typename",
            "MerchandiseTermInput",
            "refuseDutiesPermitted",
            "merchandise",
          ].includes(key) &&
          !excludedKeys.includes(key)
        ) {
          refinedObj[key] = this.refinedCheckoutObject(obj[key], excludedKeys);
        }
        if (key === "merchandise") {
          if (Array.isArray(obj[key].merchandiseLines)) {
            refinedObj[key] = {
              ...obj[key],
              merchandiseLines: this.refinedCheckoutObject(
                this.refinedMerchandiseLines(obj[key].merchandiseLines),
                excludedKeys
              ),
            };
          } else {
            refinedObj[key] = {
              ...obj[key],
              merchandiseLines: this.refinedCheckoutObject(
                obj[key].merchandiseLines,
                excludedKeys
              ),
            };
          }
        }
      });
      return refinedObj;
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  getRefinedCheckoutRequestData(addedCode = null, removedCodes = []) {
    window.logger && window.logger(this.$cart.checkoutSession);
    const checkoutSession = this.refinedCheckoutObject(
      this.$cart.checkoutSession
    );
    const delivery = {
      interfaceFlow: "SHOPIFY",
      noDeliveryRequired: [],
      prefetchShippingRatesStrategy: null,
      useProgressiveRates: true,
      deliveryLines: this.refinedDeliveryLines(
        checkoutSession.negotiate.result.sellerProposal.delivery.deliveryLines
      ),
    };
    const merchandise = {
      merchandiseLines:
        checkoutSession.negotiate.result.buyerProposal.merchandise
          .merchandiseLines,
    };
    const payment = {
      totalAmount: {
        any: true,
      },
      paymentLines: [],
      billingAddress: null,
    };
    let buyerIdentity = {
      ...checkoutSession.negotiate.result.sellerProposal.buyerIdentity,
      customer: {
        countryCode:
          checkoutSession.negotiate.result.sellerProposal.buyerIdentity.customer
            .countryCode,
        presentmentCurrency:
          checkoutSession.negotiate.result.sellerProposal.buyerIdentity.customer
            .presentmentCurrency,
      },
      contactInfoV2: checkoutSession.negotiate.result.sellerProposal
        .buyerIdentity?.contactInfoV2?.email
        ? {
            emailOrSms: {
              emailOrSmsChanged: false,
              value:
                checkoutSession.negotiate.result.sellerProposal.buyerIdentity
                  .contactInfoV2.email,
            },
          }
        : null,
      shopPayOptInPhone: {
        countryCode:
          checkoutSession.negotiate.result.sellerProposal.buyerIdentity.customer
            .countryCode,
      },
    };
    delete buyerIdentity["purchasingCompany"];
    const tip = {
      tipLines: [],
    };
    const note = checkoutSession.negotiate.result.sellerProposal.note;
    const localizationExtension =
      checkoutSession.negotiate.result.sellerProposal.localizationExtension;
    const nonNegotiableTerms =
      checkoutSession.negotiate.result.sellerProposal.nonNegotiableTerms;
    const scriptFingerprint =
      checkoutSession.negotiate.result.sellerProposal.scriptFingerprint;
    const optionalDuties =
      checkoutSession.negotiate.result.sellerProposal.optionalDuties;

    let data = {
      query: this.$cart.checkoutGraphQlQuery,
      variables: {
        checkpointData: null,
        sessionInput: {
          sessionToken: this.$cart.checkoutSessionToken,
        },
        queueToken: checkoutSession.negotiate.result.queueToken,
        discounts: {
          acceptUnexpectedDiscounts: true,
          lines:
            checkoutSession.negotiate.result.sellerProposal.merchandiseDiscount.lines
              .map((line) => {
                return {
                  allocationSet: {
                    allocated: {
                      allocations: line.allocations.allocations.map(
                        (allocation) => {
                          return {
                            amount: {
                              value: {
                                amount: allocation.amount.value.amount,
                                currencyCode:
                                  allocation.amount.value.currencyCode,
                              },
                            },
                            target: {
                              merchandiseLineTarget: {
                                atIndex: allocation.target.index,
                              },
                            },
                          };
                        }
                      ),
                    },
                  },
                  discount: line.discount.code
                    ? {
                        discountWithCode: line.discount.code,
                      }
                    : {
                        customDiscount: {
                          signature: {
                            uuid: line.discount.signatureUuid,
                            value: line.discount.signature,
                          },
                          targetEntireCart:
                            line.discount.value.appliesOnEachItem,
                          title: line.discount.title,
                          type: line.discount.type,
                          value: {
                            fixedAmountValue: {
                              value: {
                                amount:
                                  line.discount.value.fixedAmount.value.amount,
                                currencyCode:
                                  line.discount.value.fixedAmount.value
                                    .currencyCode,
                              },
                              appliesOnEachItem:
                                line.discount.value.appliesOnEachItem,
                            },
                          },
                        },
                      },
                  required: true,
                };
              })
              .filter(
                (line) => !removedCodes.includes(line.discount.discountWithCode)
              ),
        },
        delivery: delivery,
        merchandise: merchandise,
        payment: payment,
        buyerIdentity: buyerIdentity,
        tip: tip,
        note: note,
        localizationExtension: localizationExtension,
        nonNegotiableTerms: nonNegotiableTerms,
        scriptFingerprint: scriptFingerprint,
        optionalDuties: optionalDuties,
      },
      operationName: "Proposal",
    };

    if (addedCode) {
      data.variables.reduction = {
        code: addedCode,
      };
    }

    return data;
  }

  async applyDiscount() {
    const { cartItems, cartIconBubble, cartUpsell } = this.refs;
    const code = this.$input.val();

    if (!code) {
      return;
    }

    this.loading = true;

    console.log(cartItems);

    cartItems.disabled = true;
    cartIconBubble.loading = true;
    //cartUpsell.disabled = true

    try {
      await this.$cart.parseCheckoutPage();

      const checkoutData = this.getRefinedCheckoutRequestData(code);

      await this.$cart.updateCheckoutData(checkoutData);

      this.refreshDiscountCode();
      this.$input.val("");

      // Added Code for Discount Cookie
      if (this.readCookie("discount_code") !== null) {
        this.eraseCookie("discount_code");
        this.createCookie("discount_code", code, 1);
      } else {
        this.createCookie("discount_code", code, 1);
      }
      // Added Code for Discount Cookie
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
      cartItems.disabled = false;
      cartIconBubble.loading = false;
      //cartUpsell.disabled = false
    }
  }

  async removeDiscount(codes = []) {
    console.log("removeDiscount", codes);
    const { cartSummary } = this.refs;

    this.loading = true;

    try {
      await this.$cart.parseCheckoutPage();
      const requestData = this.getRefinedCheckoutRequestData(null, codes);
      await this.$cart.updateCheckoutData(requestData);
      await this.$cart.updateCheckoutData(requestData);

      this.$input.val("");

      this.refreshDiscountCode();
      cartSummary.computeDiscountedTotal();
    } catch (e) {
      console.log(e);
      //toastr.error(e)
    } finally {
      this.loading = false;
    }
  }

  refreshDiscountCode() {
    const isRedeemed = this.checkCodeApplicable();
    console.log("refreshDiscountCode");
    const { cartSummary } = this.refs;

    const $discountViewer = this.$el.find(".discount-viewer");
    this.$cart = document.querySelector("cart-drawer");

    if (isRedeemed) {
      this.codeRedeemed = true;
      $discountViewer.removeClass("hidden");
      this.refreshDiscountTag();
      cartSummary.computeDiscountedTotal();
    } else {
      this.codeRedeemed = false;

      $discountViewer.addClass("hidden");
    }
  }

  // Always check everytime items change
  checkCodeApplicable() {
    console.log("checkCodeApplicable");

    try {
      let discountErrorCodes = [];

      const appliedCodesCount =
        this.$cart.checkoutSession.negotiate.result.sellerProposal
          .merchandiseDiscount.lines.length;

      this.$cart.checkoutSession.negotiate.errors.forEach((err) => {
        if (err.code.includes("DISCOUNT")) {
          try {
            if (err.target && err.target.includes("merchandiseDiscount")) {
              const merchandiseDiscountLineIndex = parseInt(
                err.target
                  .split("$.merchandiseDiscount.lines[")[1]
                  .split("]")[0]
              );
              discountErrorCodes.push(
                this.$cart.checkoutSession.negotiate.result.buyerProposal
                  .merchandiseDiscount.lines[merchandiseDiscountLineIndex]
                  .discount.code
              );
            }
            toastr.warning(err.localizedMessageHtml, "", {
              iconClass: "toast-warning toast-chambray",
            });
          } catch (e) {
            console.log(e);
          }
        }
      });

      if (discountErrorCodes.length) {
        this.removeDiscount(discountErrorCodes);
      }

      return appliedCodesCount > 0;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  refreshDiscountTag() {
    console.log("refreshDiscountTag");
    console.log(this.$cart.checkoutSession);
    const appliedDiscount =
      this.$cart.checkoutSession.negotiate.result.sellerProposal
        .merchandiseDiscount;
    const $discountViewer = this.$el.find(".discount-viewer");
    const $discountViewerList = this.$el.find(".discount-viewer__inner_list");
    const discountCodeTemplate = this.$el
      .find("#discount-code-template")
      .html();

    $discountViewerList.html("");

    if (
      !appliedDiscount ||
      !appliedDiscount.lines.length ||
      !$discountViewer.length
    )
      return;

    appliedDiscount.lines.forEach((line, index) => {
      const discountedAmount = Currency.format(
        parseFloat(line.lineAmount.value.amount),
        { maximumFractionDigits: 2 }
      );
      const title = line.discount.title;
      const code = line.discount.code;
      const discountEl = $(discountCodeTemplate).attr("data-code", code);
      discountEl.toggleClass("is-custom-discount", !code);
      discountEl.find(".discount-viewer__content").html(`
        ${title} <span class="discounted-amount font-normal">(- ${discountedAmount})</span>
      `);
      $discountViewerList.append(discountEl);
      console.log($discountViewerList[0]);
    });
  }

  renderDiscountTag() {
    this.refreshDiscountCode();
  }
}

customElements.define("cart-redeem-code", CartRedeemCode);
